import React, { useEffect, useState } from "react";
import { Input } from "antd";

const AdminUsersSearchInput = ({ sendSearchValue }) => {
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    sendSearchValue(searchValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  return (
    <Input
      className="admin-users-search-input"
      onChange={(e) => setSearchValue(e.target.value)}
      placeholder="Търсене"
    ></Input>
  );
};

export default AdminUsersSearchInput;
